/* eslint-disable camelcase, react-hooks/rules-of-hooks */
import { useQuery, UseQueryResult, useMutation } from 'react-query';
import axios from '@utils/axios';
import { VariationSearched, VariationLookup, VariationType } from '../types';
import { useGetUserData } from './useGetUserData';

export function useGetVariationsSearched(): UseQueryResult<
  VariationSearched[]
> {
  const queryVariationsSearched = async (): Promise<VariationSearched[]> => {
    const result = await axios.get<{
      data: { searchedVariations: VariationSearched[] };
    }>(`/api/dashboard/get-variations-searched`);
    return result?.data?.searchedVariations || [];
  };

  return useQuery<VariationSearched[], Error>(
    `variations-searched`,
    () => queryVariationsSearched(),
    {
      // every 5 mins
      refetchInterval: 1000 * 60 * 5,
      onError: () => {
        console.error(
          'Something went wrong while fetching the pending deals ideas'
        );
      }
    }
  );
}

export function useGetVariationLookups(): UseQueryResult<VariationLookup[]> {
  const { data: user } = useGetUserData();
  const queryVariationsLookups = async (): Promise<VariationLookup[]> => {
    const result = await axios.get<{
      data: VariationLookup[];
    }>(`/api/user/get-variation-lookups`);
    return result?.data || [];
  };

  return useQuery<VariationLookup[], Error>(
    `variations-searched`,
    () => queryVariationsLookups(),
    {
      enabled: !!user,
      onError: () => {
        console.error('Something went wrong while fetching variation lookups');
      }
    }
  );
}

export function useResolveShortURL() {
  interface RequestData {
    URL: string;
  }

  const mutationFn = async ({
    URL
  }: RequestData): Promise<{
    fullURL: string;
  }> => {
    const result = await axios.post<{
      data: {
        fullURL: string;
      };
    }>(`/api/resolve-short`, {
      URL
    });

    return result.data;
  };

  return useMutation(mutationFn);
}

export function useGetVariationsForASIN() {
  interface RequestData {
    ASIN: string;
    isDirect: boolean;
    URL: string;
  }

  const mutationFn = async ({
    ASIN,
    isDirect,
    URL
  }: RequestData): Promise<VariationType[]> => {
    const result = await axios.post<{
      data: VariationType[];
    }>(`/api/get-variations`, {
      ASIN,
      isDirect,
      URL
    });

    return result.data;
  };

  return useMutation(mutationFn);
}
